const initState = {
    baseURL: 'https://api.achillesdrill.com/'
}

const ApiReducer = (state=initState, action)=>{
    return state
}

export default ApiReducer